var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "g",
    {
      attrs: {
        "stroke-width": "0",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#ffffff" },
        attrs: {
          d: "M188.531,458.862c-9.171,0-16.607-7.435-16.607-16.607V118.443c0-7.151,4.578-13.499,11.362-15.756 L489.263,0.849c5.063-1.684,10.629-0.835,14.958,2.287c4.329,3.121,6.894,8.133,6.894,13.47v323.812 c0,9.171-7.435,16.607-16.607,16.607s-16.607-7.435-16.607-16.607V39.636l-272.764,90.783v311.837 C205.138,451.427,197.703,458.862,188.531,458.862z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#ffffff" },
        attrs: {
          d: "M408.989,270.674c-57.267,0-102.126,30.636-102.126,69.745s44.86,69.745,102.126,69.745 s102.126-30.636,102.126-69.745S466.256,270.674,408.989,270.674z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#ffffff" },
        attrs: {
          d: "M504.222,3.137c-4.329-3.122-9.895-3.971-14.958-2.287L183.286,102.687 c-6.784,2.258-11.362,8.606-11.362,15.756v112.266l339.191-113.952V16.607C511.115,11.271,508.55,6.259,504.222,3.137z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#ffffff" },
        attrs: {
          d: "M103.012,372.51c-57.267,0-102.126,30.636-102.126,69.745s44.86,69.745,102.126,69.745 s102.126-30.636,102.126-69.745S160.278,372.51,103.012,372.51z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#ffffff" },
        attrs: {
          d: "M504.222,3.137c-4.329-3.122-9.895-3.971-14.958-2.287L341.52,50.023v123.71l169.595-56.976V16.607 C511.115,11.271,508.55,6.259,504.222,3.137z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }